module.exports = {
  appName: 'Mitsubishi',
  env: 'production', // production / test
  defaultLocale: 'fr',
  /* eslint-disable */
  buildDate: '',
  version: '',
  defaultTitle: 'Dashboard',
  env: process.env.VUE_APP_ENV || 'development', // production / test
  defaultLocale: 'fr',
  /* eslint-disable */
  apiUrl: process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'https://test-appscan.mitsubishielectric.fr/api' : '/api'),

}
